import './../../styles/project.css';

const Errors = ({ e }) => {
  return (
    <div className="app">
        <div style={{ position: 'absolute', marginLeft: '30%', marginTop: '20%' }}>
          Error: {e}
      </div>
    </div>
  );
};

export default Errors;